import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import {isArrayNotEmpty, isCompletedHotelInfoHistory, searchFirstObjectInList} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Table from '../../../molecules/Table/Table'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './Policies.scss'
import {isScandinavianProperty} from "../../../../utilities/FormHelper";

class Policies extends Component {

    constructor(props) {
        super(props)

        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE);
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO);
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY);
        const availableHotelContent = FormConst.HOTEL_CONTENT_DEFAULT_SECTIONS[hotelInfo.brandCode]

        if (!hotelCode || !hotelInfo) {
            // Go home
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            availableHotelContent: availableHotelContent !== undefined ? availableHotelContent.includes(FormConst.WEDDING_CONTENT_CODE) : false,
            policies: [],
            errorMessage: undefined,
            isLoading: false,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            policyStatus: this.getPolicyStatusFor(hotelInfo),
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    headers = ['Policy Type', 'Status', 'Action']

    getPolicyStatusFor (hotelInfo)  {
        let policyStatus = {
            'Guarantee/Cancel Policy': 'Pending',
            'Pet Policy': 'Pending',
        }

        if (hotelInfo.brandCode !== 'AE') {
            policyStatus['Group Policy'] = 'Pending'
        }

        // Only for Strawberry Hotels, Age Tiers is applicable
        if(hotelInfo.brandCode === 'SH') {
            policyStatus['Age Tiers'] = 'Pending'
        }

        return policyStatus

    }

    policyRoutes = {
        'Guarantee/Cancel Policy': RouteConst.ROUTE_GUARANTEE_CANCEL_POLICY_PAGE,
        'Pet Policy': RouteConst.ROUTE_PET_POLICY_PAGE,
        'Group Policy': RouteConst.ROUTE_GROUP_POLICY_PAGE,
        'Age Tiers': RouteConst.ROUTE_AGE_TIERS_PAGE,
    }

    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            // Getting checklist from the session when hotel status is COMPLETED
            let checklist = this.state.hotelInfoCompletedHistory.newEntity.checklist;
            if (isArrayNotEmpty(checklist)) {
                this.updateStatusFromChecklist(checklist);
            }
        } else {
            // Update status of each form when checklist info is present
            if (isArrayNotEmpty(this.props.checklist)) {
                this.updateStatusFromChecklist(this.props.checklist);
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.errorMessage) {
            this.setState({ isLoading: false, showErrorModal: true, errorMessage: 'There was an error while retrieving Policies data' })
        } else if (JSON.stringify(prevProps.checklist) !== JSON.stringify(this.props.checklist)) {
            // Update status of each form when checklist info changed
            this.updateStatusFromChecklist(this.props.checklist);
        }
    }

    /**
     * Calculates the status of each Policy page and updates their status in the state
     */
    updateStatusFromChecklist = (checklist) => {
        let guaranteeCancelStatus = 'Pending'
        let petPolicyStatus = 'Pending'
        let groupPolicyStatus = 'Pending'
        let ageTiersStatus = 'Pending'
        const isScandinavian = isScandinavianProperty(this.state.hotelInfo)
        const isAE = this.state.hotelInfo.brandCode === 'AE'
        let expectedNumberOfSections = 2
        if (!isAE) expectedNumberOfSections++
        if (isScandinavian) expectedNumberOfSections++
        if (isArrayNotEmpty(checklist)) {
            const guaranteeCancelPoliciesObject = searchFirstObjectInList('code', 'GUARANTEE_CANCEL_POLICES', checklist)
            const petPoliciesObject = searchFirstObjectInList('code', 'HOTEL_PET_POLICIES', checklist)
            const groupPoliciesObject = searchFirstObjectInList('code', 'GROUP_POLICIES', checklist)
            const ageTiersObject = searchFirstObjectInList('code', 'AGE_TIERS', checklist)
            let completedPolicyTypes = 0

            if (guaranteeCancelPoliciesObject?.processedFlag === 'COMPLETED') {
                guaranteeCancelStatus = 'Complete'
                completedPolicyTypes++
            }
            if (petPoliciesObject?.processedFlag === 'COMPLETED') {
                petPolicyStatus = 'Complete'
                completedPolicyTypes++
            }
            if (!isAE && groupPoliciesObject?.processedFlag === 'COMPLETED') {
                groupPolicyStatus = 'Complete'
                completedPolicyTypes++
            }

            if (isScandinavian && ageTiersObject?.processedFlag === 'COMPLETED') {
                ageTiersStatus = 'Complete'
                completedPolicyTypes++
            }

            let policyStatus = {
                'Guarantee/Cancel Policy': guaranteeCancelStatus,
                'Pet Policy': petPolicyStatus,
            }
            if (!isAE) {
                policyStatus['Group Policy'] = groupPolicyStatus
            }
            // Only for Strawberry Hotels, Age Tiers is applicable
            if(isScandinavian) {
                policyStatus['Age Tiers'] = ageTiersStatus
            }

            this.setState({
                policyStatus: policyStatus,
                isSectionComplete: completedPolicyTypes === expectedNumberOfSections,
                proceedButtonName: completedPolicyTypes === expectedNumberOfSections
                    ? 'Next Section' : completedPolicyTypes > 0 ? 'Continue Editing' : 'Start Editing',
                isLoading: false
            })
        }
    }

    /**
     * Handles the redirection when action button is clicked.
     * Redirects to the next pending page within the section if the section is incomplete. 
     * Redirects to the next section if this section is complete.
     */
    onClickActionButton = () => {
        if (this.state.isSectionComplete) {
            // If the section is complete, go to the next section
            this.props.history.push(SideNavEntryMapping.HOTEL_POLICIES.next?.route)
        } else {
            // Get the first pending item
            let selectedType = 'Guarantee/Cancel Policy'
            for (const type in this.state.policyStatus) {
                if (this.state.policyStatus.hasOwnProperty(type)) {
                    const status = this.state.policyStatus[type];
                    if (status === 'Pending') {
                        selectedType = type
                        break
                    }
                }
            }
            // Go to the page
            this.props.history.push({
                pathname: this.policyRoutes[selectedType],
                state: {
                    continueFlow: true
                }
            })
        }
    }

    render() {
        let tableData = []

        for (const type in this.state.policyStatus) {
            const status = this.state.policyStatus[type]
            if (this.state.policyStatus.hasOwnProperty(type)) {
                tableData.push([type, status, <NavLink to={this.policyRoutes[type]}>{status === 'Complete' ? 'Edit' : 'Add'}</NavLink>])
            }
        }

        return (
            <div className='hotel-policies-page'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to='/'>Home</NavLink></li>
                        <li className="breadcrumb-item active" aria-current="page">Hotel Policies</li>
                    </ol>
                </nav>
                <p>This section is to submit Hotel Policies details.</p>
                {
                    !this.state.isLoading
                    && (
                        <Table bordered striped headers={this.headers} data={tableData} className='hotel-policies-table' />
                    )
                }
                {
                    this.state.isSectionComplete
                    && (
                        <div className="alert alert-success" role="alert">
                            <h4 className="alert-heading">Well done!</h4>
                            <p>You successfully finished this module. Let's proceed to the <NavLink to={SideNavEntryMapping.HOTEL_CHARGES.current.route} className='alert-link'>next</NavLink> module</p>
                        </div>
                    )
                }
                <FormFooter
                    form={this.state.availableHotelContent ? SideNavEntryMapping.HOTEL_POLICIES : SideNavEntryMapping.HOTEL_POLICIES_NO_CONTENT}
                    submitName={this.state.proceedButtonName}
                    onSubmit={this.onClickActionButton}
                    noReset />
                <FormModal
                    id='hotel-policies-page-loading-modal'
                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                    hotelInfo={this.state.hotelInfo}
                    body={<h6>{this.state.loadingMessage}</h6>}
                    show={this.state.isLoading}
                    isLoadingIndicator />
                <FormModal
                    id='hotel-policies-page-error-modal'
                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                    hotelInfo={this.state.hotelInfo}
                    body={<h6>{this.state.errorMessage}</h6>}
                    isError
                    show={this.state.showErrorModal} />
            </div>
        )
    }
}

export default withFormLayout(Policies, SideNavEntryMapping.HOTEL_POLICIES)